import { render, staticRenderFns } from "./Galerie.vue?vue&type=template&id=e228a18a&"
import script from "./Galerie.vue?vue&type=script&lang=js&"
export * from "./Galerie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports